import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import BaseHeader from '@/components/BaseHeader.vue';
import BaseFooter from '@/components/BaseFooter.vue';
import Enlargement from '@/components/Enlargement.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const isLoading = computed(() => store.getters['page/status'] === 1);
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');
const showEnlargement = computed(() => store.getters['enlargement/show']);

onBeforeMount(() => {
  store.dispatch('cart/fetch');
});

onMounted(() => {
  window.addEventListener('resize', window.runIoEqualize);
  window.addEventListener('load', window.runIoEqualize);
  window.runIoEqualize();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', window.runIoEqualize);
  window.removeEventListener('load', window.runIoEqualize);
});

return (_ctx: any,_cache: any) => {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseHeader),
    (_unref(isOrderPage) && _unref(isLoading))
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(BaseFooter),
    (_unref(showEnlargement))
      ? (_openBlock(), _createBlock(Enlargement, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})